import React from 'react';

import { PartnerNote } from 'api';
import { copyText } from 'utils';

import PartnerNoteDescriptionEditor from './PartnerNoteDescriptionEditor';
import PartnerNoteDescriptionItem from './PartnerNoteDescriptionItem';
import PartnerNoteTitleItem from './PartnerNoteTitleItem';
import {
  PartnerNoteDescriptionWrapper,
  PartnerNoteItemWrapper,
} from './styles';

type PartnerNoteItemProps = {
  data: PartnerNote;
  activeFormID: string | undefined;
  onUpdateNote: (val: any) => Promise<void>;
  onDeleteNote: (val: any) => Promise<void>;
  onActiveFormID: (val: string | undefined) => void;
};

const PartnerNoteItem = ({
  data,
  onUpdateNote,
  onDeleteNote,
  onActiveFormID,
  activeFormID,
}: PartnerNoteItemProps): JSX.Element => {
  const [isCreateMode, setIsCreateMode] = React.useState(false);

  const handleShowCreateDescription = () => {
    setIsCreateMode(true);
    onActiveFormID('CREATE_DESCRIPTION');
  };

  const handleCancelCreateDescription = () => {
    setIsCreateMode(false);
    onActiveFormID(undefined);
  };

  const handleCopyText = () => {
    const text = ` - ${data.title}${data.description
      ?.map(item => `\n      * ${item.value}`)
      .join('')}`;

    copyText(text);
  };

  const handleCreateDescription = async (value: any) => {
    await onUpdateNote({
      ...data,
      description: [
        {
          id: `${Date.now()}`,
          value: value?.description ?? '',
          action: 'add',
        },
      ],
      action: 'update',
    });
    handleCancelCreateDescription();
  };

  const handleUpdateDescription = async (val: any) => {
    await onUpdateNote({
      ...data,
      description: [{ ...val, action: 'update' }],
      action: 'update',
    });
    handleCancelCreateDescription();
  };

  const handleDeleteDescription = async (val: any) => {
    await onUpdateNote({
      ...data,
      description: [{ ...val, action: 'delete' }],
      action: 'update',
    });
    handleCancelCreateDescription();
  };

  const handleUpdateNote = async (value: any) => {
    await onUpdateNote({
      ...data,
      color: value.color,
      title: value.title,
      action: 'update',
    });
    handleCancelCreateDescription();
  };

  return (
    <PartnerNoteItemWrapper>
      <PartnerNoteTitleItem
        activeFormID={activeFormID}
        data={data}
        onActiveFormID={onActiveFormID}
        onCopyNote={handleCopyText}
        onCreateDescription={handleShowCreateDescription}
        onDeleteNote={() => onDeleteNote(data)}
        onUpdateNote={handleUpdateNote}
      />
      <PartnerNoteDescriptionWrapper>
        {isCreateMode && activeFormID == 'CREATE_DESCRIPTION' && (
          <PartnerNoteDescriptionEditor
            description=""
            onCancel={handleCancelCreateDescription}
            onSubmit={handleCreateDescription}
          />
        )}
        {(data?.description || []).map(item => (
          <PartnerNoteDescriptionItem
            activeFormID={activeFormID}
            data={item}
            onActiveFormID={onActiveFormID}
            onDeleteDescription={handleDeleteDescription}
            onUpdateDescription={handleUpdateDescription}
          />
        ))}
      </PartnerNoteDescriptionWrapper>
    </PartnerNoteItemWrapper>
  );
};

export default PartnerNoteItem;
